import { SvgIcon, SvgIconProps } from "@mui/material";

export default function HelpIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 29 29">
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h28.116v28.116H0z" />
        <circle
          cx="14.058"
          cy="14.058"
          r="10.543"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.75"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.75"
          d="M14.058 19.916v.011M14.058 15.815a1.757 1.757 0 0 1 1.171-1.757 3.046 3.046 0 1 0-3.514-4.686"
        />
      </g>
    </SvgIcon>
  );
}
